import styled from 'styled-components'

export const VenueUnavailableStyles = styled.div`
	display: flex;
	min-height: 100vh;
	padding: 0 16px;
	text-align: center;
	align-items: center;
	flex-direction: column;
	justify-content: center;

	h1 {
		font-size: 20px;
		margin-bottom: 12px;
	}

	p {
		font-size: 16px;
		line-height: 1.5;
		max-width: 480px;
	}
`
